import { render } from "./PaginatedList.vue?vue&type=template&id=7c32beb8"
import script from "./PaginatedList.vue?vue&type=script&lang=js"
export * from "./PaginatedList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__